import ApiCall from "../../utils/apiCall";

const initialState = {
  isFetching: false,
  hasMore: true,
  products: []
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "listings.isFetching":
      return { ...state, isFetching: true };

    case "listings.fetchSuccess":
      const { json: apiProducts } = action.response;

      return {
        ...state,
        isFetching: false,
        products: [...apiProducts],
        hasMore: apiProducts.length > 0
      };

    case "listings.fetchNextPageSuccess":
      const { json: response } = action.response;

      return {
        ...state,
        isFetching: false,
        products: [...state.products, ...response],
        hasMore: response.length > 0
      };

    case "listings.fetchError":
      return { ...state, isFetching: false, ...action.response };

    default:
      return state;
  }
}

// Actions
export function getListings(params) {
  return async dispatch => {
    dispatch({ type: "listings.isFetching" });

    if (params.category !== undefined) {
      params.category = encodeURIComponent(params.category);
    }

    if (params.subcategory !== undefined) {
      params.subcategory = encodeURIComponent(params.subcategory);
    }

    try {
      let response = await ApiCall.get(`/listings?${toQueryString(params)}`);
      if (params.page === 1) {
        dispatch({
          type: "listings.fetchSuccess",
          response
        });
      } else {
        dispatch({
          type: "listings.fetchNextPageSuccess",
          response
        });
      }
    } catch (error) {
      dispatch({
        type: "listings.fetchError",
        error
      });
    }
  };
}

// Private
const toQueryString = object => {
  // Turn an Object into Query String Parameters format
  const serialize = Object.keys(object)
    .filter(key => object[key])
    .map(key => `${key}=${object[key].toString()}`)
    .join("&");

  return serialize;
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/listings.js